const LOG_PREFIX = "[OCM][PageSense] "
let pageSense = async (utils) => {
  return new Promise((resolve, reject) => {
    let pageType = 'ROS';
    let sub_paths = window.location.pathname.replace("/", "").split("/") || [];
    let custom_paths = [];

    sub_paths = sub_paths.filter(String);

    if (sub_paths.length === 0) {
      pageType = "Home";
    } else if (sub_paths.length === 1) {
      if (sub_paths[0].length <= 28) {
        pageType = "Category";
      } else {
        pageType = "Article";
      }
    }

    window.googletag = window.googletag || {cmd: []}

    utils.contentLoaded().then(() => {
      // Slot definitions
      defineSlots(utils, pageType)
      
      // Ad div detection and display
      let ad_placements = document.querySelectorAll('div[data-ocm-ad]')
      ad_placements.forEach((ap) => {
        window.googletag.cmd.push(() => { googletag.display(ap.id) })
      })
    })

    resolve(pageType)
  });
};

let defineSlots = (utils, pageType) => {

  window.googletag.cmd.push(() => {

    var under_menu = googletag.sizeMapping()
    .addSize([0, 0], [[300,250],[320,100],[320,50]])
    .addSize([340,0], [[300,250],[336,280],[320,100],[320,50]])
    .addSize([768, 0], [[728,90]])
    .addSize([1024, 0],[[970,250],[970,90],[728,90]])
    .build();

    var sidebar1 = googletag.sizeMapping()
    .addSize([0, 0], [[300,250],[300,600]])
    .addSize([340,0], [[300,250],[300,600],[336,280]])
    .addSize([768, 0], [[300,250],[300,600]])
    .addSize([1024, 0],[[300,250],[300,600]])
    .build();

    var sidebar2 = googletag.sizeMapping()
    .addSize([0, 0], [])
    .addSize([340,0], [])
    .addSize([768, 0], [[300,250],[300,600]])
    .addSize([1024, 0],[[300,250],[300,600]])
    .build();


    var article1 = googletag.sizeMapping()
    .addSize([0, 0], [[300,250]])
    .addSize([340,0], [[300,250],[336,280]])
    .addSize([768, 0], [[300,250],[336,280]])
    .addSize([1024, 0],[[300,250],[728,90],[336,280]])
    .build();

    var inline = googletag.sizeMapping()
    .addSize([0, 0], [[300,250],[300,600]])
    .addSize([340,0], [[300,250],[336,280],[300,600]])
    .addSize([768, 0], [[300,250],[336,280]])
    .addSize([1024, 0],[[300,250],[336,280]])
    .build();

    var article2 = googletag.sizeMapping()
    .addSize([0, 0], [[300,250]])
    .addSize([340,0], [[300,250],[336,280]])
    .addSize([768, 0], [[300,250],[336,280]])
    .addSize([1024, 0],[[300,250],[336,280]])
    .build();

    googletag.defineSlot('/75351959,22645609195/militaire.gr/under_menu', [[970,250],[970,90],[728,90],[300,250],[336,280],[320,100],[320,50]], 'div-gpt-ad-1549837563642-0').defineSizeMapping(under_menu).addService(googletag.pubads())

    switch(pageType) {
      case 'Home':

        googletag.defineSlot('/75351959,22645609195/militaire.gr/hp_sidebar1', [[300,250],[336,280],[300,600]], 'div-gpt-ad-1549837563642-1').defineSizeMapping(sidebar1).addService(googletag.pubads())
        googletag.defineSlot('/75351959,22645609195/militaire.gr/hp_sidebar2', [[300,250],[336,280],[300,600]], 'div-gpt-ad-1549837563642-2').defineSizeMapping(sidebar1).addService(googletag.pubads())
        googletag.defineSlot('/75351959,22645609195/militaire.gr/under_slider', [[970,250],[970,90],[728,90],[300,250],[336,280],[320,100],[320,50]], 'div-gpt-ad-1549837563642-8').defineSizeMapping(under_menu).addService(googletag.pubads())
        googletag.defineSlot('/75351959,22645609195/militaire.gr/hp_sidebar3', [[300,250],[336,280],[300,600]], 'div-gpt-ad-1549837563642-9').defineSizeMapping(sidebar1).addService(googletag.pubads())
        googletag.defineSlot('/75351959,22645609195/militaire.gr/billboard', [[970,250],[970,90],[728,90],[300,250],[336,280],[320,100],[320,50]], 'div-gpt-ad-1549837563642-10').defineSizeMapping(under_menu).addService(googletag.pubads())
        googletag.defineSlot('/75351959,22645609195/militaire.gr/billboard2', [[970,250],[970,90],[728,90],[300,250],[336,280],[320,100],[320,50]], 'div-gpt-ad-1549837563642-13').defineSizeMapping(under_menu).addService(googletag.pubads())

        break;

      case 'Category':

        break;

      case 'Article':
        if (!utils.is_mobile) {
          googletag.defineSlot('/75351959,22645609195/militaire.gr/ros_sidebar1', [[300,250],[300,600]], 'div-gpt-ad-1549837563642-6').defineSizeMapping(sidebar2).addService(googletag.pubads())
          googletag.defineSlot('/75351959,22645609195/militaire.gr/ros_sidebar2', [[300,250],[300,600]], 'div-gpt-ad-1549837563642-7').defineSizeMapping(sidebar2).addService(googletag.pubads())
          googletag.defineSlot('/75351959,22645609195/militaire.gr/ros_sidebar3', [[300,250],[300,600]], 'div-gpt-ad-1549837563642-12').defineSizeMapping(sidebar2).addService(googletag.pubads())
        }

        break;

      default:
        break;
    }
  })
}

module.exports = pageSense;